var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.68 80.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2,.cls-3{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}.cls-3{stroke-linecap:square;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clear-dayAsset 157colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.25,15.51A24.8,24.8,0,1,0,65,40.31,24.83,24.83,0,0,0,40.25,15.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.25,15.51A24.8,24.8,0,1,0,65,40.31,24.83,24.83,0,0,0,40.25,15.51Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.21,
    y1: 15.51,
    x2: 40.21,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.47,
    y1: 65.17,
    x2: 40.47,
    y2: 78.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.17,
    y1: 40.21,
    x2: 78.68,
    y2: 40.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.51,
    y1: 40.47,
    x2: 2,
    y2: 40.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.7,
    y1: 22.88,
    x2: 13.14,
    y2: 13.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.99,
    y1: 57.81,
    x2: 67.54,
    y2: 67.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.81,
    y1: 22.7,
    x2: 67.36,
    y2: 13.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.88,
    y1: 57.99,
    x2: 13.32,
    y2: 67.54
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDay);
export default __webpack_public_path__ + "static/media/clear-day.55f155dffdd173d4bbe51b73a7b573c2.svg";
export { ForwardRef as ReactComponent };